import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import {
  stepReducer,
  loginReducer,
  otpReducer,
  merchantReducer,
  merchantSwitchReducer,
  employeeReducer,
  employeePhotoReducer,
  employeeManagementReducer,
  authListSliceReducer,
  serviceErrorReducer,
  PassRefPersonelInfoReducer,
  PassRefCardInfoReducer,
  IntegratorListReducer,
  SimModalReducer,
  TimeOutReducer,
  WebSecurityReducer,
} from "./slices";

export const store = configureStore({
  reducer: {
    step: stepReducer,
    login: loginReducer,
    otp: otpReducer,
    merchant: merchantReducer,
    merchantSwitch: merchantSwitchReducer,
    employee: employeeReducer,
    employeePhoto: employeePhotoReducer,
    employeeManagement: employeeManagementReducer,
    authList: authListSliceReducer,
    serviceInlineError: serviceErrorReducer,
    PassRefPersonelInfo: PassRefPersonelInfoReducer,
    PassRefCardInfo: PassRefCardInfoReducer,
    IntegratorList: IntegratorListReducer,
    simmodal: SimModalReducer,
    timeOut: TimeOutReducer,
    WebSecurity: WebSecurityReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
